export default [
  "$uibModalInstance",
  "$scope",
  "InvestActivityService",
  "Notification",
  "data",
  "activeYear",
  function ($modalInstance, $scope, InvestActivityService, Notification, data, activeYear) {
    $scope.ok = ok;
    $scope.loading = false;
    $scope.cancel = cancel;
    $scope.getYearClass = function (year) {
      return year == $scope.selectedYear ? "selected" : "";
    };

    $scope.selectTypes = [
      { id: 1, name: "тыс. руб" },
      { id: 2, name: "млн. руб" },
    ];
    $scope.startYear = 2000;
    // Если loop, то указываем количество слайдов на вью;
    $scope.slidesPerViewOffset = 0;
    $scope.slides = Array(61).fill(null).map((_, index) => $scope.startYear + index);
    $scope.selectedYear = activeYear || $scope.startYear;
    $scope.data = {
      ...angular.copy(data),
      planFunds: data.planFunds.reduce((acc ,red) => {
        acc[red.year] = red;
        return acc;
      }, {})
    };
    $scope.federalBudget = 0;
    $scope.municipalityBudget = 0;
    $scope.areaBudget = 0;
    $scope.outbudget = 0;

    $scope.totalProducts = 0;
    $scope.toalService = 0;
    $scope.workPlaces = 0;
    $scope.productExchange = 0;

    // $scope.value = 1;
    // $scope.values = ["one", "two", "three", "four", "five", "six", "seven"];
    $scope.changedSlide = function (swiper) {
      const index = (swiper.activeIndex - $scope.slidesPerViewOffset) % $scope.slides.length;
      $scope.selectedYear = $scope.slides[index];
      $scope.$apply();
    };

    $scope.slideInit = function (swiper) {
      if (!activeYear) return;
      swiper.slideTo(activeYear - $scope.startYear + $scope.slidesPerViewOffset, 0, true, true);
    };

    function ok() {
      handleNewData();
      $scope.loading = true;
      const request = data.initialData;
      request.planFunds = $scope.data.planFunds;
      request.federalBudget = $scope.data.planFunds
        .reduce((acc, cur) => acc + (cur.federalBudget || 0), 0);
      request.municipalityBudget = $scope.data.planFunds
        .reduce((acc, cur) => acc + (cur.municipalityBudget || 0), 0);
      request.areaBudget = $scope.data.planFunds
        .reduce((acc, cur) => acc + (cur.areaBudget || 0), 0);
      request.outbudget = $scope.data.planFunds
        .reduce((acc, cur) => acc + (cur.outbudget || 0), 0);

      const successCallback = (result) => {
        $scope.loading = false;
        $modalInstance.close({ isNeedReload: true, idOfNewActivity: result._embedded });
      }
      const errorCallback = (err) => {
        Notification.danger({
          title: 'Ошибка!',
          message: err ? err.data ? err.data.status + ':' + err.data.message : err.message || err : "Произошла ошибка при сохранении."
        });
        $scope.loading = false;
      }

      (data.initialData.id
        ? InvestActivityService.api.update({ investactivityId: data.initialData.id }, request)
        : InvestActivityService.api.create(request)
      ).$promise
      .then(successCallback)
      .catch(errorCallback);
    }

    function cancel() {
      $modalInstance.dismiss(false);
    }

    function handleNewData(year = $scope.selectedYear) {

      $scope.data.planFunds = Object.entries($scope.data.planFunds)
      .map(el => {
        if ("year" in el[1]) return el[1];
        el[1].year = Number(el[0]);
        return el[1];
      })
      .map(n => ({
        ...n,
        federalBudget: n.federalBudget || 0,
        areaBudget: n.areaBudget || 0,
        municipalityBudget: n.municipalityBudget || 0,
        outbudget: n.outbudget || 0,
        totalProducts: n.totalProducts || 0,
        toalService: n.toalService || 0,
        workPlaces: n.workPlaces || 0,
        productExchange: n.productExchange || 0,
      }))
      .sort((a, b) => a.year - b.year)
      .filter(n => n.federalBudget || n.municipalityBudget || n.areaBudget || n.outbudget || n.totalProducts || n.toalService || n.workPlaces || n.productExchange);
    }
  },
];
